import * as types from "../constants/promoYoutube";

const initialState = {
  youtube: [],
  loading: false,
  error: false,
};

const promoYoutube = (state = initialState, { type, ...action }) => {
  switch (type) {
    case types.GET_PROMO_YOUTUBE:
      return {
        ...state,
        loading: true,
        error: false,
      };

    case types.SET_PROMO_YOUTUBE:
      return {
        ...state,
        youtube: action.youtube,
        loading: false,
        error: false,
      };

    case types.ERROR_PROMO_YOUTUBE:
      return {
        ...state,
        youtube: [],
        loading: false,
        error: true,
      };

    default:
      return state;
  }
};

export default promoYoutube;
